import React from 'react'
import Component from 'components/component'

import FilterForm from 'components/ae-sidebar-filter/filter-form'

export default class AESidebarFilterDesktop extends Component {
  render() {
    return (
      <div className="ae-sidebar-filter">
        <div className="vod-filter">
          <FilterForm {...this.props} />
        </div>
      </div>
    )
  }
}
